<script setup lang="ts">
import type { CustomerListItem } from '@entities/customer'
import type { CustomerBrand } from '@shared/config'

import { faCommentDots } from '@fortawesome/pro-regular-svg-icons'
import { faCrown } from '@fortawesome/pro-solid-svg-icons'

import { AppBadge, BadgeCustomerBrand } from '@shared/ui/badges'
import { AppTooltip } from '@shared/ui/tooltips'
import { LinkTextPrimary } from '@shared/ui/links'
import { AppIcon } from '@shared/ui/icons'

import { getCustomerUrl } from '../../model/list/customer-links'

defineOptions({
  name: 'CustomerFullName',
})

const props = defineProps<{
  customer: CustomerListItem
}>()

const refBrand = computed<CustomerBrand>(() => props.customer.brand as CustomerBrand)
const refName = computed<string>(() => `${props.customer.first_name} ${props.customer.last_name}`.trim())
</script>

<template>
  <span class="customer-full-name">
    <AppTooltip
      v-if="customer.is_premium"
      text="Premium tutor bought"
      size="small"
      placement="top"
    >
      <AppIcon
        :icon="faCrown"
        size="small"
        color="amber-500"
      />
    </AppTooltip>
    <AppTooltip
      v-if="customer.is_premium_tutor_trial"
      text="Premium tutor trial"
      size="small"
      placement="top"
    >
      <AppIcon
        :icon="faCrown"
        size="small"
        color="blue-500"
      />
    </AppTooltip>
    <AppBadge
      v-if="customer.is_go"
      color="emerald"
      text="Goal"
      title="GO lead"
    />
    <BadgeCustomerBrand
      :brand="refBrand"
      view="icon"
    />
    <LinkTextPrimary :href="getCustomerUrl(customer.id)">
      {{ refName }}
    </LinkTextPrimary>
    <AppTooltip
      v-if="customer.notes"
      :text="customer.notes"
      size="small"
      placement="top"
    >
      <AppIcon
        :icon="faCommentDots"
        size="small"
        color="slate-400"
      />
    </AppTooltip>
  </span>
</template>

<style scoped lang="scss" src="./CustomerFullName.scss" />
